import { HighlightOffOutlined } from "@mui/icons-material";
import {
  Button,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import * as React from "react";
import { useSetRecoilState } from "recoil";
import { USE_ACTION_DRAWER } from "../../../../hooks/useActionDrawer";
import { useCart } from "../../../../hooks/useCart";
import { useXoraiaValue } from "../../../../hooks/useXoraia";
import { IArticleData } from "../../../../utils/interfaces/common/XArticle.interfaces";

const CartList: React.FC = () => {
  const { imageComponent, env, Link } = useXoraiaValue();
  const { cart, setCart } = useCart();
  const setDrawer = useSetRecoilState(USE_ACTION_DRAWER);

  if (cart.carts.length === 0) {
    return (
      <Stack p={3} alignItems="center" justifyContent="center">
        <Typography>Votre Panier est vide</Typography>
      </Stack>
    );
  }

  const removeArticle = async (article: IArticleData) => {
    try {
      setCart((old) => {
        const carts = old.carts.filter((e) => e.id !== article.id);

        return { ...old, carts };
      });
    } catch (error) {
      console.error("REMOVE ARTICLE FROM CART =>", error);
    }
  };

  return (
    <React.Fragment>
      <List
        disablePadding
        sx={{
          flex: 1,
          fontFamily: "inherit",
          "& .MuiListItem-container:not(:last-of-type)": {
            borderBottom: 1,
            borderBottomColor: "rgba(0, 0, 0, 0.12)",
          },
        }}
      >
        {cart.carts.map(({ id, images, name, price, qty }) => {
          return (
            <ListItem key={id} alignItems="flex-start">
              {imageComponent && (
                <ListItemAvatar
                  sx={{
                    width: "60px",
                    height: "70px",
                    position: "relative",
                  }}
                >
                  {imageComponent(
                    {
                      src: images[0],
                      alt: name,
                      width: "60px",
                      height: "70px",
                    },
                    env ?? "prod",
                    {},
                    "article id"
                  )}
                </ListItemAvatar>
              )}
              <ListItemText
                sx={{ mx: 1 }}
                primary={name}
                primaryTypographyProps={{
                  sx: {
                    fontFamily: "inherit",
                    mb: 2,
                    lineHeight: "1em",
                    fontWeight: 600,
                  },
                }}
                secondaryTypographyProps={{ component: "div" }}
                secondary={
                  <>
                    <Typography
                      sx={{
                        lineHeight: "1em",
                        fontFamily: "inherit",
                        mb: 1.5,
                        "& span": { color: "#999999", mr: 1 },
                      }}
                    >
                      <span>{qty}</span>
                      <span>X</span>
                      <b>{price} F CFA</b>
                    </Typography>
                    {/* <Select
                      native
                      size="small"
                      defaultValue={qty}
                      sx={{ "& .MuiSelect-select": { py: "5px" } }}
                    >
                      {Array(10)
                        .fill("")
                        .map((_, i) => (
                          <option key={i.toString()} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                    </Select> */}
                  </>
                }
              />
              <ListItemSecondaryAction>
                <IconButton
                  size="small"
                  color="error"
                  onClick={async () =>
                    await removeArticle({ images, id } as any)
                  }
                >
                  <HighlightOffOutlined />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
      </List>
      <Typography
        sx={{
          fontFamily: "inherit",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
          py: 1.5,
          px: 2,
          borderTop: 1,
          borderBottom: 1,
          borderColor: "#EEEEEE",

          "& b": {
            fontSize: 24,
          },
        }}
      >
        <span>Sous Total</span>
        <b>
          {cart.carts.reduce((prev, cur) => {
            return prev + cur.price * cur.qty;
          }, 0)}{" "}
          F CFA
        </b>
      </Typography>
      <Button
        disableElevation
        sx={{ m: 2 }}
        size="large"
        variant="contained"
        color="primary"
        href="/checkout"
        LinkComponent={Link}
        onClick={() => setDrawer(null)}
      >
        COMMANDER
      </Button>
    </React.Fragment>
  );
};

export default CartList;
